export const REQUEST_GOAL_PROGRESS = "request_goal_progress"
export const GOAL_PROGRESS_SUCCESS = "goal_progress_success"
export const GOAL_PROGRESS_FAILURE = "goal_progress_failure"

export const CLEAR_GOAL_PROGRESS = "clear_goal_progress"